import { callable } from '../callable';

export interface UserItemViewDto {
  itemId: string;
  sectionId: string | null;
  viewedAt: string;
  completedAt: string | null;
}

// Siempre del alumno de la sesión: el servidor lo resuelve (lib/own-student).
export const userItemViewApi = {
  listMine: async (data: {
    tenantId: string;
    sectionId?: string;
  }): Promise<{ items: UserItemViewDto[] }> => {
    const fn = callable<typeof data, { items: UserItemViewDto[] }>('listMyItemViews');
    return (await fn(data)).data;
  },
  markViewed: async (data: {
    tenantId: string;
    itemId: string;
    sectionId?: string;
  }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('markItemViewed');
    return (await fn(data)).data;
  },
  setCompleted: async (data: {
    tenantId: string;
    itemId: string;
    sectionId?: string;
    completed: boolean;
  }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('setItemCompleted');
    return (await fn(data)).data;
  },
};
